<template>
  <div :style="cssVar">
    <div class="single-data-chart">
      <e-chart :option="singleOption" autoresize />
    </div>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'ChecksBarChart',
  props: {
    checkActionCount: {
      type: Number,
      required: true,
    },
  },
  mixins: [stringUtils],
  computed: {
    cssVar() {
      return {
        // 26px bar height + 12px space = 38px in total
        // 1* since we're having only one bar
        '--chart-height': `${1 * 38}px`,
      }
    },
    singleOption() {
      const series = [
        {
          name: this.$t('reporting.industry.checks.checked'),
          value: this.checkActionCount,
          itemStyle: { color: '#458fc8' },
        },
      ]

      return this.barGraphOptions(
        series.map(entry => entry.name),
        series,
      )
    },
  },
  methods: {
    barGraphOptions(yAxisData, seriesData, axisLabel) {
      return {
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          inverse: true, // Display longer bars at top
          type: 'category',
          data: yAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 24,
            fontWeight: '700',
            fontSize: 16,
            fontFamily: 'Source Sans Pro',
            color: '#314053',
            width: 120,
            ...axisLabel,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: '100px', // 215px so the longest label text "Completely wrong Fraction" isn't cut off
          right: 0,
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            barWidth: 26,
            backgroundStyle: {
              borderRadius: 4,
              color: '#a1a1a1',
            },
            barCategoryGap: 12,
            itemStyle: {
              borderRadius: 4,
              color: '#314053',
            },
            label: {
              show: true,
              position: ['60px', '6px'],
              color: 'black',
              fontWeight: 700,
              fontSize: 16,
              fontFamily: 'Source Sans Pro',
              align: 'right',
            },
            showBackground: true,
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.single-data-chart {
  height: var(--chart-height);
}

.total-data-chart {
  height: 2rem;
  margin-bottom: 1.5rem;
}
</style>
